// @flow

import baseSchema, {
  findDependentAlertTypeSchema,
  findSchemaPropertyByName,
  findSchemaRequired,
  baseUiSchema,
} from "./base-schema";
import type { Schemas } from "./types";

export const schema = (schema: ?Object) => {
  const typeSchema = findDependentAlertTypeSchema(schema, "WORK_RELATED");

  return {
    ...baseSchema,
    properties: {
      ...baseSchema.properties,
      workRelated: {
        required: findSchemaRequired(typeSchema, "workRelated"),
        title: "Work Related",
        properties: {
          days: {
            type: "number",
            multipleOf: 0.01,
            title: "Days",
          },
          dayType: findSchemaPropertyByName(typeSchema, "workRelated", "dayType"),
        },
        type: "object",
      },
    },
    required: [...baseSchema.required, "workRelated"],
  };
};

export const uiSchema = (t: (s: string) => string) => baseUiSchema(t);

const schemas: Schemas = {
  schema,
  uiSchema,
};

export default schemas;
